'use strict';

module.exports = {
  template: require('./manager-import.html'),
  controller: require('./manager-import.controller.js'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/manager-import/index.js
 ** module id = 148
 ** module chunks = 0
 **/